// removed by extract-text-webpack-plugin
module.exports = {"mobileAuthenticationTooltip":"_3AO8--8kPMZUJUPrOlbPRb","phoneVerificationTooltip":"_1NtqMkwCPWQbigxWgVJni2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTooltip/OMTooltipMobile.scss
// module id = 1680
// module chunks = 0